import {put,call} from 'redux-saga/effects';
import { constants } from '../../constants';
import {toggleAlertShowStatus} from '../actions';
import MulesoftDataService from '../../services/mulesoftData.services';

export default function * acceptedTerms(args){
    try {
        yield call([MulesoftDataService,'acceptedTerms'],args);
    } catch (error) {
        yield put(toggleAlertShowStatus({
            showAlert: true,
            alertVarient:'danger',
            alertMessage: constants.APP_MESSAGE.API_RETRIVE_ERROR
          }));
    }
}